import React, { useEffect, useState } from 'react';
import { Storage, Translate, translate } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { updateEntity as updateBank } from 'app/entities/bank/bank.reducer';
import { AUTHORITIES } from 'app/config/constants';

export function PostPurchaseSetting() {
  const dispatch = useAppDispatch();
  const account = useAppSelector(state => state.authentication.account);
  const bankEntity = useAppSelector(state => state.bank.entity);

  const userRoleAccessList = useAppSelector(state => state.userManagement.userRoleAccessList);
  const isUserAuthorizedToEdit = userRoleAccessList.length === 0 || userRoleAccessList.some(role => role.bankId === bankEntity?.id);

  const [postPurchaseCollapse, setPostPurchaseCollapse] = useState(true);
  const [requireDocumentUpload, setRequireDocumentUpload] = useState(false);

  const handlePostPurchaseCollapse = () => {
    setPostPurchaseCollapse(prev => !prev);
  };

  const handleRequireDocumentUploadChange = () => {
    setRequireDocumentUpload(prev => !prev);
  };

  const handleSubmit = () => {
    const updatedBank = {
      ...bankEntity,
      requireDocumentUpload,
    };
    dispatch(updateBank(updatedBank));
  };

  useEffect(() => {
    if (bankEntity?.id !== undefined) {
      if (bankEntity?.requireDocumentUpload !== undefined) {
        setRequireDocumentUpload(bankEntity.requireDocumentUpload);
      }
    }
  }, [bankEntity]);

  return (
    <div className="collapse-section">
      <Grid container className="align-items-center">
        <Grid item xs={10} sm={11} md={11.5}>
          <Typography variant="h5" component="div" data-cy="postPurchaseSettingHeading">
            {translate('comexApp.bank.details.postPurchaseSetting.title')}
          </Typography>
        </Grid>
        <Grid item xs={2} sm={1} md={0.5}>
          <IconButton aria-label="collapse" onClick={handlePostPurchaseCollapse}>
            {postPurchaseCollapse ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
          </IconButton>
        </Grid>
      </Grid>
      <Collapse in={postPurchaseCollapse}>
        <TableContainer className="my-3" sx={{ maxHeight: 320 }}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell style={{ borderBottom: 'none' }}>
                  <Grid container sx={{ alignItems: 'center' }}>
                    <Grid item sm={10} md={10}>
                      <Typography
                        variant="body1"
                        component={'div'}
                        style={{ fontWeight: 700 }}
                        align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                      >
                        {translate('comexApp.bank.details.postPurchaseSetting.requireDocumentUpload')}
                      </Typography>
                      <Typography
                        variant="body2"
                        component={'div'}
                        sx={{
                          mt: 0.5,
                          color: 'text.secondary',
                        }}
                        align={Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'}
                      >
                        {translate('comexApp.bank.details.postPurchaseSetting.requireDocumentUploadHelp')}
                      </Typography>
                    </Grid>
                    <Grid item sm={2} md={2} sx={{ display: 'inline-flex', justifyContent: 'center' }}>
                      <Tooltip
                        title={
                          requireDocumentUpload
                            ? translate('comexApp.bank.details.postPurchaseSetting.tooltip.enabled')
                            : translate('comexApp.bank.details.postPurchaseSetting.tooltip.disabled')
                        }
                      >
                        <Switch
                          checked={requireDocumentUpload}
                          onChange={handleRequireDocumentUploadChange}
                          name="requireDocumentUpload"
                          disabled={
                            (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) &&
                              !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BANK)) ||
                            !isUserAuthorizedToEdit
                          }
                          data-cy="requireDocumentUpload"
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="submit"
            color="primary"
            onClick={handleSubmit}
            value={0}
            disabled={
              (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && !account?.authorities?.includes(AUTHORITIES.SUBADMIN_BRANCH)) ||
              !isUserAuthorizedToEdit
            }
          >
            {translate('comexApp.bank.details.update')}
          </Button>
        </Box>
      </Collapse>
    </div>
  );
}
